// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AboutRouteImport } from './routes/about'
import { Route as AlliancesRouteImport } from './routes/alliances'
import { Route as ExpressRouteImport } from './routes/express'
import { Route as JourneysRouteImport } from './routes/journeys'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const AlliancesRoute = AlliancesRouteImport.update({
            id: '/alliances',path: '/alliances',getParentRoute: () => rootRouteImport
          })
const ExpressRoute = ExpressRouteImport.update({
            id: '/express',path: '/express',getParentRoute: () => rootRouteImport
          })
const JourneysRoute = JourneysRouteImport.update({
            id: '/journeys',path: '/journeys',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,AboutRoute: AboutRoute,AlliancesRoute: AlliancesRoute,ExpressRoute: ExpressRoute,JourneysRoute: JourneysRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)